<form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
    <div class="search_section  d-lg-flex">
        <ng-autocomplete class="searchbox" formControlName="s" placeholder="I'm searching for" [data]="data"
            [searchKeyword]="keyword" (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)'
            (inputCleared)='onInputCleared($event)' (opened)='onPanelOpen($event)' (inputFocused)='onFocused($event)'
            [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
        </ng-autocomplete>
        <input type="image" class="search_icon" src="assets/images/research.svg">
        <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.keyword"></a>
        </ng-template>
        <ng-template #notFoundTemplate let-notFound>
            <div [innerHTML]="notFound"></div>
        </ng-template>
    </div>
</form>